import { render, staticRenderFns } from "./StocktakingRuleList.vue?vue&type=template&id=6f8ffa69&scoped=true&"
import script from "./StocktakingRuleList.vue?vue&type=script&lang=js&"
export * from "./StocktakingRuleList.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingRuleList.vue?vue&type=style&index=0&id=6f8ffa69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ffa69",
  null
  
)

export default component.exports